import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getAppVersionInfo(params) {
  return request({
    url: '/GetAppVersionInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 601,
      MessageID: btcguid(),
      Data: {
      }
    }
  })
}

export function addAppVersionInfo(params) {
  return request({
    url: '/AddAppVersionInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 602,
      MessageID: btcguid(),
      Data: {
        Version: params.Version,
        UpdateLog: params.UpdateLog,
        UpdateDate: params.UpdateDate,
        DownloadURL: params.DownloadURL
      }
    }
  })
}

export function deleteAppVersionInfo(params) {
  return request({
    url: '/DeleteAppVersionInfo',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 603,
      MessageID: btcguid(),
      Data: {
        AppUpdateID: params.AppUpdateID
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/app.js